/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_REBATE_PROGRAM = 'GET_REBATE_PROGRAM';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_ERROR_MSG_PAYMENT_SUMMARY = 'GET_ERROR_MSG_PAYMENT_SUMMARY';
export const GET_PAYMENT_SUMMARY = 'GET_PAYMENT_SUMMARY';
export const DISPLAY_REPORT_OPTION = 'DISPLAY_REPORT_OPTION';
export const DISPLAY_TIME_PERIOD = 'DISPLAY_TIME_PERIOD';
export const DISPLAY_YEAR = 'DISPLAY_YEAR';
export const DISPLAY_STATE_FISCAL = 'DISPLAY_STATE_FISCAL';
export const GET_FROM_PAYMENT = 'GET_FROM_PAYMENT';
export const GET_TO_PAYMENT = 'GET_TO_PAYMENT';
export const SET_DISPLAY_OBJ_PAYMENT = 'SET_DISPLAY_OBJ_PAYMENT';
export const GET_DISPLAY_DATES = 'GET_DISPLAY_DATES';
export const SET_REFRESH_DATA = 'SET_REFRESH_DATA';
export const SET_REFRESH_DATA_DISPLAY = 'SET_REFRESH_DATA_DISPLAY';
export const GET_REBATE_PROGRAM_NAME = 'GET_REBATE_PROGRAM_NAME';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ = 'GET_CURRENT_DISPLAY_DETAIL_OBJ';
export const GET_CURRENT_DISPLAY_OBJ = 'GET_CURRENT_DISPLAY_OBJ';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
